import { render } from "./ForgotPasswordComponent.vue?vue&type=template&id=c45ddda4&scoped=true"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"

import "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=c45ddda4&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45ddda4"]])

export default __exports__